// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"checkbox---checkboxLabel---Xfz8k"};